var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4249_14631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 60.667C46.5685 60.667 60 47.2355 60 30.667C60 14.0984 46.5685 0.666992 30 0.666992C13.4315 0.666992 0 14.0984 0 30.667C0 47.2355 13.4315 60.667 30 60.667Z",
    fill: props.fill
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7473 28.7004C43.6498 30.2954 45.6198 33.3817 45.6198 36.9242C45.6198 38.7279 45.1085 40.4129 44.2248 41.8429C44.2248 41.8429 44.7785 43.7579 45.151 45.0454C45.2148 45.2679 45.151 45.5079 44.9835 45.6692C44.816 45.8304 44.5735 45.8854 44.3535 45.8117C43.1223 45.4017 41.3235 44.8042 41.3235 44.8042C39.8598 45.7504 38.116 46.2992 36.2448 46.2992C32.691 46.2992 29.5973 44.3179 28.0073 41.4017C34.6735 40.6479 39.9735 35.3604 40.7473 28.7004ZM16.2323 33.4042C15.0623 31.5542 14.3848 29.3629 14.3848 27.0142C14.3848 20.4017 19.7535 15.0342 26.3648 15.0342C32.9773 15.0342 38.3448 20.4017 38.3448 27.0142C38.3448 33.6254 32.9773 38.9942 26.3648 38.9942C24.1223 38.9942 22.0223 38.3767 20.226 37.3017C20.226 37.3017 17.2173 38.1717 15.5135 38.6642C15.291 38.7279 15.051 38.6642 14.8898 38.4967C14.7285 38.3292 14.6735 38.0867 14.7473 37.8667C15.291 36.2329 16.2323 33.4042 16.2323 33.4042Z",
    fill: "#E7E7E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4249_14631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0 0.666992)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon_chat.6bc98ca3228f253285d0449c3244e425.svg";
export { ForwardRef as ReactComponent };